const Header = () => {
  return (
    <div className="header">
      <div className="header__primary-heading e-mf">
        <h1>creative developer</h1>
      </div>
      <div className="header__secondary-heading text-R-large">
        Design and develop beautiful experiences meticulously for web, games and
        animations
      </div>
    </div>
  );
};
export default Header;
